module.exports = __webpack_public_path__ + "src/assets/games/58/2.png";